import { usePoolsByPair } from "../gql/hooks/pools.query";
import { transformAssetIdToGqlAssetId } from "../utils/assets.utils";

interface IUseAvailablePoolsArgs {
  givenAssetId?: string;
  takenAssetId?: string;
}
export const useAvailablePools = ({ givenAssetId, takenAssetId }: IUseAvailablePoolsArgs) => {
  const [coinA, coinB] = [givenAssetId, takenAssetId]
    .filter((id) => typeof id === "string")
    .map((id: string) => transformAssetIdToGqlAssetId(id))
    .sort();

  const { data, ...rest } = usePoolsByPair({
    coinA,
    coinB,
  });

  return {
    availablePools: data.sort((a, b) => Number(b.quantityLP) - Number(a.quantityLP)),
    ...rest,
  };
};
